import './DocumentDeliverySection.scss';

import React from 'react';

const DocumentDeliverySection = ({ children }) => {
  return (
    <div className="document-delivery-section">
      <div className="document-delivery-section-headers">
        <div className="document-delivery-section-title">Document</div>
        <div className="document-delivery-section-toggle-headers">
          <div className="document-delivery-method">Email</div>
          <div className="document-delivery-method">U.S. Mail</div>
        </div>
      </div>
      <div className="document-delivery-section-content">{children}</div>
    </div>
  );
};

export default DocumentDeliverySection;
